<ng-container
  *ngIf="
    orders?.length && charges?.length && paymentAmount && profile;
    else loading
  "
>
  <p>To complete the order you are required to make a payment of:</p>
  <h3>
    {{
      profile?.selectedLocation?.country?.currencySymbol
    }}{{ paymentAmount | number: '.2-2' }}
  </h3>
  <!--  TODO REPLACE WITH CUSTOM FLOW WHERE WE SHOW THE OPTIONS HERE WITHOUT REDIRECTING TO TINGG-->
  <p>This transaction will be secured and verified by PayGate a DPO Company</p>
  <div class="col-12 md:col-3">
    <a href="https://dpogroup.com/"
    ><img
      alt="Payment methods Via, Mastercard processed securely by PayGate a DPO Company"
      class="payment-methods"
      src="/assets/layout/images/vendors/PayGate-Card-Brand-Logos-PayGate.png"
    /></a>
  </div>

  <p>
    <strong
    >Please note if you do not make payment the supplier might not process
      your order.</strong
    >
  </p>
  <button
    (click)="initializePayment()"
    [disabled]="savingTransaction$ | async"
    class="p-button p-button-primary"
  >Proceed to payment</button>
  <div *ngIf="savingTransaction$ | async">Gathering payment data...</div>
</ng-container>
<ng-template #loading>
  <boma-anim-spinning-loader [size]="80"></boma-anim-spinning-loader>
</ng-template>
